import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SVGIcon, checkCircleIcon } from '@progress/kendo-svg-icons';

import { CFDocumentStoreService } from '../../services/documents/cf-document-store.service';

@Component({
    selector: 'clfl-thanks-for-signing',
    templateUrl: './thanks-for-signing.component.html',
    styleUrls: ['./thanks-for-signing.component.scss']
})
export class ThanksForSigningComponent implements OnInit {
    public checkCircleIcon: SVGIcon = checkCircleIcon;
    public fileUrl: any = undefined;
    constructor(
        private sanitizer: DomSanitizer,
        private documentStoreService: CFDocumentStoreService
    ) {}

    ngOnInit(): void {
        const blob = this.documentStoreService.latestDocumentBlob;
        if (blob) {
            this.documentStoreService.latestDocumentBlob = undefined;
            this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
        }
    }
}
